import { render, staticRenderFns } from "./StockRequestDraftTable.vue?vue&type=template&id=9b99bfe4"
import script from "./StockRequestDraftTable.vue?vue&type=script&lang=js"
export * from "./StockRequestDraftTable.vue?vue&type=script&lang=js"
import style0 from "./StockRequestDraftTable.vue?vue&type=style&index=0&id=9b99bfe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports